import { AccountData } from "@markit/common.types";
import ProfilePageFull from "./ProfilePageFull";
import { useProfilePageFullData } from "../../hooks/useProfilePageFullData";

type ProfilePageWrapperProps = {
  userData: AccountData;
};

// To group the useHook and the ProfilePageFull together
const ProfilePageWrapper = (props: ProfilePageWrapperProps) => {
  const { userData } = props;

  const {
    loadingEvents,
    userAttendingEvents,
    userEvents,
    eventOrganizers,
    tabItem,
    setTabItem,
    profilePages,
    setProfilePages,
  } = useProfilePageFullData({ userData });

  return (
    <ProfilePageFull
      userData={userData}
      loadingEvents={loadingEvents}
      userAttendingEvents={userAttendingEvents}
      userEvents={userEvents}
      eventOrganizers={eventOrganizers}
      tabItem={tabItem}
      setTabItem={setTabItem}
      profilePages={profilePages}
      setProfilePages={setProfilePages}
    />
  );
};

export default ProfilePageWrapper;
